/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Gemini_Web_OpenInputs */

const en_mcp_gemini_web_open = /** @type {(inputs: Mcp_Gemini_Web_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On gemini.google.com, open Settings, then Connected Apps. You may need to choose Personal Intelligence first.`)
};

const es_mcp_gemini_web_open = /** @type {(inputs: Mcp_Gemini_Web_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En gemini.google.com, abre Settings y luego Connected Apps. Puede que primero tengas que elegir Personal Intelligence.`)
};

/**
* | output |
* | --- |
* | "On gemini.google.com, open Settings, then Connected Apps. You may need to choose Personal Intelligence first." |
*
* @param {Mcp_Gemini_Web_OpenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_gemini_web_open = /** @type {((inputs?: Mcp_Gemini_Web_OpenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Gemini_Web_OpenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_gemini_web_open(inputs)
	return en_mcp_gemini_web_open(inputs)
});